<template>
  <div class="bg-main">
    <v-container>
      <v-row justify="center">
        <v-expansion-panels accordion focusable>
          <v-expansion-panel>
            <v-expansion-panel-header>Dados Pessoais</v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-container>
                <v-row align="center" justify="center">
                  <v-col cols="12" sm="6" md="4" xl="2">
                    <form>
                      <v-text-field
                          color="green"
                          disabled
                          v-model="cidadao.cpf"
                          v-mask="'###.###.###-##'"
                          label="CPF"
                      ></v-text-field>
                      <v-text-field
                          color="green"
                          v-model="cidadao.nome"
                          label="Nome"
                          disabled
                      ></v-text-field>
                      <v-text-field
                          v-model="cidadao.dataNascimento"
                          label="Data de Nascimento"
                          disabled
                      ></v-text-field>
                      <v-radio-group disabled v-model="cidadao.genero" column>
                        <template v-slot:label>
                          <div class="theme_secondary--text">Gênero:</div>
                        </template>
                        <v-radio color="green" label="Masculino" value="M"></v-radio>
                        <v-radio color="green" label="Feminino" value="F"></v-radio>
                      </v-radio-group>
                      <v-text-field
                          v-model="cidadao.nomeMae"
                          label="Nome Completo da Mãe"
                          disabled
                      ></v-text-field>
                      <v-select
                          v-model="cidadao.nacionalidade"
                          :items="nacionalidades"
                          label="Nacionalidade"
                          item-text="gentilico"
                          item-value="sigla"
                          readonly
                      ></v-select>
                      <v-select
                          v-model="cidadao.estadoCivil"
                          :items="estadosCivis"
                          label="Estado Civil"
                          item-text="estado"
                          item-value="codigo"
                          readonly
                      ></v-select>
                      <v-layout class="d-flex justify-space-between">
                        <v-flex lg3>
                          <v-select
                              v-model="tipoContatoTelefone1"
                              :items="tiposContatos"
                              item-text="opcao"
                              item-value="tipoContatoTelefone"
                              label="Tipo"
                              readonly
                          ></v-select>
                        </v-flex>
                        <v-flex lg8>
                          <v-text-field
                              color="green"
                              v-model="cidadao.telefoneContato1"
                              v-mask="maskFoneCelular"
                              label="Telefone para Contato (Obrigatório)"
                              required
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                      <v-layout class="d-flex justify-space-between">
                        <v-flex lg3>
                          <v-select
                              v-model="cidadao.tipoContatoTelefone2"
                              :items="tiposContatos"
                              item-text="opcao"
                              item-value="tipoContatoTelefone"
                              label="Tipo"
                              persistent-hint
                              single-line
                          ></v-select>
                        </v-flex>
                        <v-flex lg8>
                          <v-text-field
                              v-if="mascaraCelular"
                              color="green"
                              v-model="cidadao.telefoneContato2"
                              v-mask="maskFoneCelular"
                              label="Telefone para Contato (Opcional)"
                              required
                          ></v-text-field>
                          <v-text-field
                              v-if="mascaraConvencional"
                              color="green"
                              v-model="cidadao.telefoneContato2"
                              v-mask="maskFoneConvencional"
                              label="Telefone para Contato (Opcional)"
                              required
                          ></v-text-field>
                        </v-flex>
                      </v-layout>

                      <v-row justify="center" align="center">
                        <v-btn color="primary" class="mr-4"
                               @click="saveDadosPessoais">Salvar
                        </v-btn>
                      </v-row>
                    </form>
                  </v-col>
                </v-row>
              </v-container>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel>
            <v-expansion-panel-header>Dados Residenciais</v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-container>
                <v-row align="center" justify="center">
                  <v-col cols="12" sm="6" md="4" xl="2">
                    <form>
                      <v-text-field
                          color="green"
                          v-model="cidadao.cep"
                          v-mask="'#####-###'"
                          @change="getAddressByCep()"
                          placeholder="99999-999"
                          label="CEP"
                      ></v-text-field>
                      <v-layout class="d-flex justify-space-between">
                        <v-flex lg3>
                          <v-text-field
                              color="green"
                              v-model="cidadao.tipoLogradouro"
                              label="Tipo de Logradouro "
                          ></v-text-field>
                        </v-flex>
                        <v-flex lg8>
                          <v-text-field
                              color="green"
                              v-model="cidadao.logradouro"
                              label="Logradouro"
                          ></v-text-field>
                        </v-flex>


                      </v-layout>

                      <v-text-field
                          color="green"
                          v-model="cidadao.numero"
                          label="Número da Casa ou Apartamento"
                      ></v-text-field>
                      <v-text-field
                          color="green"
                          v-model="cidadao.complemento"
                          label="Complemento"
                      ></v-text-field>
                      <v-text-field
                          color="green"
                          v-model="cidadao.bairro"
                          label="Bairro"
                      ></v-text-field>
                      <v-text-field
                          color="green"
                          v-model="cidadao.municipio.nome"
                          label="Município de Residência"
                      ></v-text-field>

                      <v-row justify="center" align="center">
                        <v-btn color="primary" class="mr-4"
                               @click="saveDadosResidenciais">Salvar
                        </v-btn>
                      </v-row>
                    </form>
                  </v-col>
                </v-row>
              </v-container>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel>
            <v-expansion-panel-header>Dados Contatos</v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-container>
                <v-row align="center" justify="center">
                  <v-col cols="12" sm="6" md="4" xl="2">
                    <v-alert
                        type="error"
                        icon="mdi-alert-circle"
                        transition="scale-transition"
                    >Este será seu e-mail de recuperação de senha, lembre-se dele pois será utilizado nas comunicações e
                      recuperações de senha.
                    </v-alert>

                    <v-form class="mb-8">
                      <v-text-field
                          v-model="cidadao.email"
                          color="green"
                          label="E-mail de contato e recuperação de senha"
                          required
                      ></v-text-field>
                      <v-text-field
                          v-model="cidadao.confirmaEmail"
                          color="green"
                          label="Confirmar e-mail de contato e recuperação de senha"
                          required
                      ></v-text-field>
                      <div class="text-center">
                        <v-btn color="primary" class=""
                               @click="saveDadosAcesso">Salvar
                        </v-btn>
                      </div>
                    </v-form>
                    <v-divider></v-divider>
                    <div class="text-center mt-2">
                      <a target="_blank"
                         href="https://acesso.redegoverno.am.gov.br/auth/realms/am/login-actions/reset-credentials?client_id=conta">
                        ALTERAR SENHA
                      </a>
                    </div>
                  </v-col>
                </v-row>
              </v-container>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-row>
    </v-container>
    <v-dialog v-if="mostraDialogo"
              v-model="dialog"
              width="500"
    >

      <v-card>
        <v-card-title class="d-flex justify-space-around headline green darken-1 text-lg-center">
          <span class="text-h5 text-lg-center white--text" v-text="dialog.titulo"></span>
        </v-card-title>

        <v-card-text class="h2">
          <p class="subtitle-1 text-lg-center">{{dialog.mensagem}}</p>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
              class=""
              color="error"
              @click="mostraDialogo = false"
          >
            Fechar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import getEstadosCivis from "../../../cadastro-cidadao-redegoverno/src/db/json/civilstates.json";

export default {
  name: "Cadastro",
  data: () => ({
    dialog: {
      titulo:"",
      mensagem:""
    },
    mostraDialogo: false,
    tiposContatos: [{opcao:"Celular",tipoContatoTelefone:"C"}, {opcao:"Residencial",tipoContatoTelefone:"R"}, {opcao:"Trabalho",tipoContatoTelefone:"T"}],
    tipoContatoTelefone1:{opcao:"Celular",tipoContatoTelefone:"C"},
    tipoContatoTelefone2: "",
    estadosCivis : [{
      codigo:"",
      estado:""
    }],
    cep: '',
    nacionalidades: null,
    municipios: '',
    address: "",
    telefoneResidencial: null,
    telefoneCelular: null,
    maskFoneConvencional: "(##) ####-####",
    maskFoneCelular: "(##) #####-####",
  }),
  created() {
    console.log("Cadastro created",this.cidadao);
    this.getNacionalidades();
    this.estadosCivis = getEstadosCivis;
    this.listMunicipios();

  },
  mounted() {
    console.log('Cadastro mounted')
    if (this.cidadao) {
      this.telefoneCelular = this.cidadao.telefoneCelular;
      this.telefoneResidencial = this.cidadao.telefoneResidencial;
    }
  },
  computed: {
    mascaraCelular(){
      console.log('mascaraCelular',this.tipoContatoTelefone2)
      return(this.cidadao.tipoContatoTelefone2 == "C" ||this.cidadao.tipoContatoTelefone2 == "T");
    },
    mascaraConvencional(){
      return(this.cidadao.tipoContatoTelefone2 == "R");
    },
    ...mapGetters({
        cidadao: 'cidadao/cidadao'
    }),
    cpf() {
      return ''//this.$options.filters.VueMask('###.###.###-##', this.cidadao.cpf);
    }
  },
  methods: {

    async getNacionalidades(){
      try {
        const resultado = await this.$store.dispatch("cidadao/getNacionalidadesApi");
        this.nacionalidades = resultado.data;
      } catch (error) {
        console.log(error);
      }
    },

    async listMunicipios() {
      try {
        const res = await this.$store.dispatch("cidadao/listMunicipios");
        this.municipios = res.data;
        console.log("Municipios", this.municipios)
      } catch (error) {
        console.log(error);
      }
    },
    async getAddressByCep() {
      try {
        var RePonto = new RegExp("\\.", "g");
        var ReTraco = new RegExp("\\-", "g");
        this.cep = this.cidadao.cep.replace(RePonto, "");
        this.cep = this.cep.replace(ReTraco, "");
        const res = await this.$store.dispatch('cidadao/getAddressByCepModule', this.cep);
        this.address = res.data;
        this.cidadao.logradouro = this.address.logradouro;
        this.cidadao.bairro = this.address.bairro;
        const municipio = this.municipios.find(elemento => elemento.nome == this.address.localidade);
        this.cidadao.municipio = municipio;
      } catch (e) {
        console.log(e)
      }
    }
    ,
    async saveDadosPessoais() {
      this.mostraDialogo = false;
      console.log('saveDadosPessoais');
      let payload = {
        telefoneContato1: this.cidadao.telefoneContato1,
        telefoneContato2: this.cidadao.telefoneContato2,
        tipoContatoTelefone1: 'C',
        tipoContatoTelefone2: this.cidadao.tipoContatoTelefone2,
      }
      try{
        await this.$store.dispatch('cidadao/saveDadosPessoais', payload);
        this.dialog.titulo = "Sucesso"
        this.dialog.mensagem = 'Dados pessoais salvos com sucesso'
        this.mostraDialogo=true;

      }catch (e) {
        this.dialog.titulo = "Erro"
        this.dialog.mensagem = 'Erro ao salvar os dados pessoais '+e;
        this.mostraDialogo=true;
        console.log(e)
      }

    }
    ,
    async saveDadosResidenciais() {
      let payload = {
        bairro: this.cidadao.bairro,
        cep: this.cidadao.cep,
        complemento: this.cidadao.complemento,
        logradouro: this.cidadao.logradouro,
        municipioId: this.cidadao.municipio.id,
        numero: this.cidadao.numero,
        tipoLogradouro: this.cidadao.tipoLogradouro
      }
      try{
        await this.$store.dispatch('cidadao/saveDadosResidenciais', payload);
        this.dialog.titulo = "Sucesso"
        this.dialog.mensagem = 'Dados residenciais salvos com sucesso'
        this.mostraDialogo=true;
      }catch (e) {
        this.dialog.titulo = "Erro"
        this.dialog.mensagem = 'Erro ao salvar os dados pessoais '+e;
        this.mostraDialogo=true;
      }
    },
    async saveDadosAcesso() {
      let payload = {
        email: this.cidadao.email
      }
      await this.$store.dispatch('cidadao/saveDadosAcesso', payload);
      this.dialog.titulo = "Sucesso"
      this.dialog.mensagem = 'Dados de acesso salvos com sucesso'
      this.mostraDialogo=true;
    }
  }
}
</script>

<style scoped>

</style>
